import {environment} from '../../../environments/environment';

export class GmcApi {
  host = environment.host;
  uploadsHost = environment.uploadsHost;
  usersApi = `${this.host}/user`;
  servicesApi = `${this.host}/services`;
  pagesApi = `${this.host}/pages`;
  pagesAllApi = `${this.pagesApi}/all`;
  paymentsApi = `${this.host}/payments`;
  mailboxApi = `${this.host}/mailbox`;
  plansApi = `${this.host}/plans`;
  vacanciesApi = `${this.pagesApi}/vacancies`;
  vacancyApi = `${this.host}/vacancy`;
  applicantsApi = `${this.host}/applicants`;

  auth = {
    login: `${this.usersApi}/signin`,
    logout: `${this.usersApi}/logout`,
    restorePassword: `${this.usersApi}/recoveryPassword`,
    register: `${this.usersApi}/register`
  };

  user = {
    getProfile: `${this.usersApi}/getMyProfile`,
    getAllUsers: `${this.usersApi}/getUsersCounters`,
    deleteProfile: `${this.usersApi}/deleteMyProfile`,
    updateProfile: `${this.usersApi}/updateMyProfilePersonalData`,
    updatePhoto: `${this.usersApi}/uploadProfileAvatar`,
    updateBasicProfile: `${this.usersApi}/updateBasicProfile`,
    updateCandidateProfile: `${this.usersApi}/updateCandidateProfile`,
    changePassword: `${this.usersApi}/changePassword`,
    experience: {
      getAll: `${this.usersApi}/getMyJobExperience`,
      update: `${this.usersApi}/updateMyJobExperience`,
      remove: `${this.usersApi}/deleteMyJobExperience`,
      loadCompanyInfo: `${this.usersApi}/uploadJobImage`
    },
    hiringOn: {
      get: `${this.usersApi}/getMyProfileHiringOn`,
      update: `${this.usersApi}/updateMyProfileHiringOn`
    },
    getByIntegerId: `${this.usersApi}/getUserByIntegerId`,
    activate: `${this.usersApi}/activate`,
    profileFillPoints: `${this.usersApi}/checkCandidateProfileFillPoints`,
    getAllCandidatesLight: `${this.usersApi}/getAllCandidatesLight`,
    getAllEmployersLight: `${this.usersApi}/getAllEmployersLight`
  };

  services = {
    get: `${this.servicesApi}`,
    getTypes: `${this.servicesApi}/types`
  };

  helpers = {
    getAllLanguages: `${this.pagesAllApi}/getAllLanguages`,
    getCountries: `${this.pagesAllApi}/getAllCountries`,
    getAllCities: `${this.pagesAllApi}/getAllCities`,
    getRanks: `${this.pagesAllApi}/getAllRanks`,
    getPositions: `${this.pagesAllApi}/getAllPositions`,
    getNationalities: `${this.pagesAllApi}/getAllNationalities`,
    getUsersCounters: `${this.usersApi}/getUsersCountersWithOnline`,
    getRoles: `${this.pagesAllApi}/getAllRoles`,
    getCurrencies: `${this.paymentsApi}/getCurrency`,
    getMilestone: `${this.pagesAllApi}/getUserCounterByDateWeb`,
    currentBalance: `${this.paymentsApi}/getMyBalance`,
    companies: `${this.usersApi}/getAllCompanies`
  };

  company = {
    get: `${this.usersApi}/getMyProfileCompanyData`,
    update: `${this.usersApi}/updateMyProfileCompanyData`
  };

  chat = {
    uploadFile: `${this.usersApi}/uploadChatFile`
  };

  vacancy = {
    get: `${this.vacanciesApi}/getVacancy`,
    getLight: `${this.vacanciesApi}/all/light`,
    changeActivity: `${this.vacanciesApi}/changeVacancyActive`,
    createOrUpdate: `${this.vacanciesApi}/addOrUpdateVacancy`,
    create: `${this.vacanciesApi}/addVacancy`,
    update: `${this.vacanciesApi}/updateVacancy`,
    isVacancyMine: `${this.vacanciesApi}/isThisVacancyMine`,
    remove: `${this.vacanciesApi}/deleteVacancy`,
    helperVars: `${this.vacanciesApi}/getPageVars`,
    uploadVacancyLogo: `${this.vacanciesApi}/uploadVacancyImage`,
    lastVacancy: `${this.vacanciesApi}/getMyLastActiveVacancy`,
    topOnVacancy: `${this.paymentsApi}/topVacancy`,
    lists: {
      top: `${this.vacanciesApi}/filter`,
      posted: `${this.vacanciesApi}/getMyVacancies`,
      employersPosted: `${this.vacanciesApi}/getEmployerVacancies`
    },
    applyToVacancy: `${this.vacanciesApi}/apply`,
    autoApplyVacancy: `${this.paymentsApi}/autoApplyVacancy`,

    topOnce: `${this.vacanciesApi}/topVacancy`,
    autoTop: `${this.paymentsApi}/autoTopVacancy`,

    getApplicantsNow: `${this.servicesApi}/getApplicantsCount`,

    getCvCreationVariables: `${this.vacancyApi}/pageVariables`,

    // applyToVacancy: `${this.vacanciesApi}/apply`,
    // getApplicantsNow: `${this.servicesApi}/getApplicantsCount`,
    all: `${this.vacancyApi}/all`,
  };

  employer = {
    top: `${this.usersApi}/getAllEmployers`,
    getContacts: `${this.usersApi}/getMyContacts`,
    info: `${this.usersApi}/getEmployerInfo`
  };

  mailbox = {
    addToImportant: `${this.mailboxApi}/setImportant`,
    deleteFromImportant: `${this.mailboxApi}/deleteFromImportant`,
    addMessage: `${this.mailboxApi}/addMessage`,
    deleteMessage: `${this.mailboxApi}/deleteMessage`,
    getMessages: `${this.mailboxApi}/getMyMessages`,
    getMessage: `${this.mailboxApi}/getMessage`
  };

  candidates = {
    all: `${this.usersApi}/getAllCandidates`,
    applicants: `${this.vacanciesApi}/getAllApplicants`,
    favorites: `${this.usersApi}/getMyFavorites`,
    favoritesList: `${this.usersApi}/getMyFavoritesList`,
    crew: `${this.usersApi}/getMyCrew`,
    count: `${this.usersApi}/getUsersCounters`,
    addToFavorites: `${this.usersApi}/addToFavorite`,
    addToMyCrew: `${this.usersApi}/addToMyCrew`,
    removeFromFavorite: `${this.usersApi}/deleteFromFavorite`,
    removeFromMyCrew: `${this.usersApi}/deleteFromMyCrew`,
    updateNote: `${this.usersApi}/addNote`,
    getNote: `${this.usersApi}/getNote`
  };

  cv = {
    all: `${this.usersApi}/getAllCV`,
    one: `${this.usersApi}/getCV`,
    incomingCV: `${this.host}/cv`,
    incomeCV: `${this.host}/cv/income`,
    deleteCv: `${this.host}/cv`,
    favorite: `${this.usersApi}/favoriteCV`,
    remove: `${this.usersApi}/deleteCV`,
    create: '',
    update: `${this.usersApi}/updateCV`,

    topOnce: `${this.paymentsApi}/topCV`,
    autoTop: `${this.paymentsApi}/autoTopCV`
  };

  transactions = {
    addMoney: `${this.paymentsApi}/addRandomMoney`
  };

  plans = {
    getPlans: `${this.plansApi}/getPlans`,
    buyPlan: `${this.plansApi}/buyPlan`,
    revalidatePlan: `${this.plansApi}/revalidatePlan`
  };
  payments = {
    createPaymentEx: `${this.paymentsApi}/createPaymentEx`,
    paymentsHistory: `${this.paymentsApi}/getMyPayments`,
    getPaymentsActions: `${this.paymentsApi}/getPaymentsActions`,
    getWithdrawValues: `${this.paymentsApi}/getWithdrawValues`
  };

  smartServices = {
    autoTopCv: `${this.servicesApi}/autoTopCV`,
    topCv: `${this.servicesApi}/topCV`,
    getMyServicesTypes: `${this.servicesApi}/types`,
    getMyServices: `${this.servicesApi}`,
    getMyService: `${this.servicesApi}/service`,
    preApplyCheck: `${this.servicesApi}/apply/check`,
    preSendCVCheck: `${this.servicesApi}/preSendCVCheckWeb`,
    applyVacancy: `${this.servicesApi}/apply/`,
    sendCv: `${this.servicesApi}/sendCV`,
    autoSendCVToUser: `${this.servicesApi}/autoSendCVToUser`,
    autoSendCVToUsers: `${this.servicesApi}/autoSendCVToUsers`,
    topVacancy: `${this.servicesApi}/topVacancy`,
    autoTopVacancy: `${this.servicesApi}/autoTopVacancy`,
    autoApplyVacancy: `${this.servicesApi}/autoApplyVacancy`
  };

}



// WEBPACK FOOTER //
// ./app/core/constants/gmc-api.ts